import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { SvgIcon } from 'common/react/components/SvgIcon';
import { getTranslation } from 'common/react/utils/translations';
import { PlayerModalVotes } from './player-modal-votes';
import { playerModalSelector } from 'common/store/modules/player-awards/player-modal/selectors';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';

/**
 * Brownlow Player Modal - Player Details section
 *
 * @param {object} props
 * @param {string} props.playerId
 *
 * @param props.playerName
 * @returns
 */
export const PlayerModalDetails = ({ playerId, playerName }) => {
    const modal = useSelector(playerModalSelector);
    const isPredictor = modal.isPredictor;
    const compAbbr = PULSE.app.common.match.getCompAbbr(modal?.seasonPid);
    const isAFLW = compAbbr.toLowerCase() === 'aflw';

    /* eslint-disable camelcase */
    const playerProfileTrackingInfo = {
        event: PULSE.app.common.CONSTANTS.TRACKING.EVENTS.SELECT.CTA,
        linkText: getTranslation('label.stats.playerProfile'),
        component_name: isAFLW
            ? 'aflw player profile'
            : 'brownlow player profile',
        component_type: isAFLW
            ? 'aflw player profile button'
            : 'brownlow player profile button',
        component_content_type: isAFLW
            ? 'aflw player profile'
            : 'brownlow player profile'
    };
    /* eslint-enable camelcase */

    return (
        <div className="player-awards-player-modal__player-details-container">
            <div className="player-awards-player-modal__player-name-container">
                <span className="player-awards-player-modal__first-name">
                    {modal.player.givenName}
                </span>
                <span className="player-awards-player-modal__last-name">
                    {modal.player.surname}
                </span>
            </div>

            <div className="player-awards-player-modal__buttons-container">
                {playerId && (
                    <PlayerProfileLink
                        classes="player-awards-player-modal__button"
                        player={{
                            playerId: playerId,
                            firstName: modal?.player.givenName,
                            surname: modal?.player.surname
                        }}
                        isExternal={true}
                        isAFLW={isAFLW}
                        trackingInfo={playerProfileTrackingInfo}
                    >
                        <SvgIcon
                            icon="person"
                            folder="elements"
                            subfolder="stats"
                            className="icon"
                        />
                        {getTranslation('label.stats.playerProfile')}
                    </PlayerProfileLink>
                )}
            </div>

            <PlayerModalVotes
                isPredictor={isPredictor}
                playerName={playerName}
            />
        </div>
    );
};

PlayerModalDetails.propTypes = {
    playerId: PropTypes.string.isRequired,
    playerName: PropTypes.string
};
